const Admin = () => {
  return <h1 data-testid="title">Admin</h1>;
};
export default Admin;
